import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Collapse,
  IconButton,
  LinearProgress,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { VisibilityOutlined as VisibilityIcon } from "@mui/icons-material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useDispatch, useSelector } from "react-redux";
import { setActiveHorizontalIndex, setActiveVerticalIndex } from "../../services/redux/slices/stepperDynamicFormSlice";
import { ROUTES } from "../../routes/routerConfig";
import { useNavigate } from "react-router-dom";
import { trackCustomerJourneyEvent } from "../../utils/ga";
import { decrypt } from "../../utils/crypto";
import { RootState } from "../../services/redux/store";
// --- Props Interface ---
export interface SubStep {
  verticalStepName: string;
  completionRate?: string | number;
}

export interface CollapsibleSectionProps {
  icon?: React.ElementType<any>;
  title: string;
  subtitle?: string;
  completionRate?: string;
  isCompleted?: boolean;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  isProvisionalOfferTab?: boolean;
  provisionalOfferBtnClick?: () => void;
  paddingTopTabZero?: boolean;
  isProvisionalOffer?: any;
  isProvisionalGenerated?: boolean;
  partnerStartedJourney?: boolean;
  subSteps?: SubStep[];
  headerContent?: React.ReactNode;
  pageTypeSummary?: string;
  actionLabel?: string;
  actionDisabled?: boolean;
  onAction?: () => void;
  applicationStatus?:string;
}

const getSubStepProgress = (rate?: string | number): number => {
  if (typeof rate === "number") return Math.max(0, Math.min(100, rate));
  if (typeof rate === "string") {
    const v = Number(rate.replace("%", "").trim());
    if (!Number.isNaN(v)) return Math.max(0, Math.min(100, v));
  }
  return 0;
};

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  icon: Icon,
  title,
  subtitle,
  completionRate,
  isExpanded,
  isCompleted,
  onToggle,
  children,
  isProvisionalOfferTab,
  provisionalOfferBtnClick,
  paddingTopTabZero,
  isProvisionalOffer,
  isProvisionalGenerated,
  partnerStartedJourney,
  subSteps,
  headerContent,
  pageTypeSummary,
  actionLabel,
  actionDisabled,
  onAction,
  applicationStatus
}) => {
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  let completerate=  completionRate;
 if(title==="Applicant & Loan Details" && completionRate==="83.33%" ){
    completerate= "100%";
 }
  const dispatch = useDispatch();
  const navigate = useNavigate();

   const trackingId = useSelector((state: RootState) => state.stepper?.trackingId);

  const gotoDynamicForm = (step: any) => {
    switch (step.verticalStepName) {
      case "Verify Yourself and Provide Consent":
          dispatch(setActiveHorizontalIndex(0));
          dispatch(setActiveVerticalIndex(0));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Provide Course Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_COURSE_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_COURSE_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_COURSE_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_COURSE_DETAILS",
              page: "Existing Application_View Summary_Continue_coursedetails",
            }
          );
          dispatch(setActiveHorizontalIndex(0));
          dispatch(setActiveVerticalIndex(1));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Provide Loan Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              page: "Existing Application_View Summary_Continue_loandetails",
            }
          );
          dispatch(setActiveHorizontalIndex(0));
          dispatch(setActiveVerticalIndex(2));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Student Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_STUDENT_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_STUDENT_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_STUDENT_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_STUDENT_DETAILS",
              page: "Existing Application_View Summary_Continue_studentdetails",
            }
          );
          dispatch(setActiveHorizontalIndex(1));
          dispatch(setActiveVerticalIndex(0));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Address Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_ADDRESS_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_ADDRESS_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_ADDRESS_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_ADDRESS_DETAILS",
              page: "Existing Application_View Summary_Continue_addressdetails",
            }
          );
          dispatch(setActiveHorizontalIndex(1));
          dispatch(setActiveVerticalIndex(1));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Employment Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_EMPLOYMENT_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_EMPLOYMENT_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_EMPLOYMENT_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_EMPLOYMENT_DETAILS",
              page: "Existing Application_View Summary_Continue_employmentdetails",
            }
          );
          dispatch(setActiveHorizontalIndex(1));
          dispatch(setActiveVerticalIndex(2));
          navigate(ROUTES.Application.applyNow.locationPath);
          break;
      case "Academic Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_ACADEMIC_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_ACADEMIC_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_ACADEMIC_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_ACADEMIC_DETAILS",
              page: "Existing Application_View Summary_Continue_academicdetails",
            }
          );
          dispatch(setActiveHorizontalIndex(1));
          dispatch(setActiveVerticalIndex(3));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Entrance Exam Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_ENTRANCE_EXAMS_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_ENTRANCE_EXAMS_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_ENTRANCE_EXAMS_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_ENTRANCE_EXAMS_DETAILS",
              page: "Existing Application_View Summary_Continue_entranceexamsdetails",
            }
          );
          dispatch(setActiveHorizontalIndex(1));
          dispatch(setActiveVerticalIndex(4));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Co-Applicant Details":
            // On Hold
            trackCustomerJourneyEvent(
              "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              "",
              trackingId,
              {
                label: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
                category: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
                action: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
                page: "Existing Application_View Summary_Continue_loandetails",
              }
            );
          dispatch(setActiveHorizontalIndex(1));
          dispatch(setActiveVerticalIndex(5));
          navigate(ROUTES.Application.applyNow.locationPath);
          break;
      case "Applicant Additional Details":
      case "Additional Applicant Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_APPLICANT_ADDITIONAL_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_APPLICANT_ADDITIONAL_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_APPLICANT_ADDITIONAL_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_APPLICANT_ADDITIONAL_DETAILS",
              page: "Existing Application_View Summary_Continue_applicantadditionaldetails",
            }
          );
          dispatch(setActiveHorizontalIndex(3));
          dispatch(setActiveVerticalIndex(0));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Co-Applicant Additional Details":
      case "Co-Applicant Aditional Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              page: "Existing Application_View Summary_Continue_coapplicant",
            }
          );
          dispatch(setActiveHorizontalIndex(3));
          dispatch(setActiveVerticalIndex(1));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Funds and Expenses":
      case "Funds & Expenses":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_FUNDS_AND_EXPENSE_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_FUNDS_AND_EXPENSE_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_FUNDS_AND_EXPENSE_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_FUNDS_AND_EXPENSE_DETAILS",
              page: "Existing Application_View Summary_Continue_Funds&Expensedetails",
            }
          );
          dispatch(setActiveHorizontalIndex(3));
          dispatch(setActiveVerticalIndex(2));
          navigate(ROUTES.Application.applyNow.locationPath);
          break; 
      case "Reference Details":
      case "Collateral Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_REFERENCE_AND_COLLATERAL_DETAILS",
            "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_REFERENCE_AND_COLLATERAL_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_REFERENCE_AND_COLLATERAL_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_REFERENCE_AND_COLLATERAL_DETAILS",
              page: "Existing Application_View Summary_Continue_Referenced&Collateraldetails",
            }
          );
          dispatch(setActiveHorizontalIndex(3));
          dispatch(setActiveVerticalIndex(3));
          navigate(ROUTES.Application.applyNow.locationPath);
          break;     
      default:
        break;
    }
  }
  const firstIncompleteIndex =subSteps &&  subSteps?.findIndex(step => step.completionRate !== "100%");
  return (
    <Paper
      sx={{
        p: isXsOrSm ? 1 : 2.5,
        mb: 2,
        borderRadius: "8px",
        border: "1px solid rgba(0, 0, 0, 0.04)",
        boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          pb: isExpanded ? 2 : 0,
          borderBottom: isExpanded ? "1px solid #eee" : "none",
        }}
        onClick={onToggle}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: 1, minWidth: 0 }}>
          {Icon && pageTypeSummary !== "loansummary" && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 40,
                height: 40,
                borderRadius: "6px",
                bgcolor: "#e0f7fa",
              }}
            >
              <Icon
                sx={{
                  fontSize: "1.5rem",
                  color: "#d3ebebff",
                }}
              />
            </Box>
          )}
          <Box sx={{ minWidth: 0, flex: 1, pl: 1 }}>
            <Typography variant="body1" sx={{ fontWeight: 600, color: "#333" }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "0.75rem",
                  color: "#a4a1a1ff",
                }}
              >
                {subtitle}
              </Typography>
            )}
            {!partnerStartedJourney && completionRate && (
              <Box sx={{ mt: 0.75, display: "flex", alignItems: "center", gap: 1, width: "100%", maxWidth: isXsOrSm ? 160 : 240 }}>
                <LinearProgress
                  variant="determinate"
                  value={Number(completerate?.replace("%", "") || "0")}
                  sx={{
                    width: isXsOrSm ? 100 : 160,
                    flexShrink: 0,
                    height: 4,
                    minHeight: 4,
                    maxHeight: 4,
                    borderRadius: 4,
                    backgroundColor: "#e0f7fa",
                    "& .MuiLinearProgress-bar": { backgroundColor: "#00b3b5", borderRadius: 4 },
                  }}
                />
                <Typography sx={{ fontSize: "0.68rem", fontWeight: 500, color: "#a4a1a1ff", whiteSpace: "nowrap" }}>
                  Completion Rate:{" "}
                  <Typography component="span" sx={{ fontWeight: 700, color: "#00b3b5", fontSize: "0.68rem" }}>
                    {completerate}
                  </Typography>
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

        {isXsOrSm && (
          <Box>
            {isProvisionalOfferTab ? (
              <Button
                variant="outlined"
                onClick={provisionalOfferBtnClick}
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  textTransform: "capitalize",
                  border: "none",
                  color: "#00b3b5",
                }}
                startIcon={<VisibilityIcon />}
                disabled={!isProvisionalOffer}
              >
                View
              </Button>
            ) : pageTypeSummary !== "loansummary" ?
              <IconButton size="small" sx={{ color: "#616161" }}>
                {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
              </IconButton> : null}
          </Box>
        )}

        {!isXsOrSm && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {actionLabel ? (
              <Button
                variant="contained"
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  onAction?.();
                }}
                disabled={actionDisabled}
                sx={{
                  textTransform: "capitalize",
                  backgroundColor: actionDisabled ? "#e0e0e0" : "#00b3b5",
                  color: actionDisabled ? "#6b6b6b" : "#fff",
                  '&:hover': {
                    backgroundColor: actionDisabled ? "#e0e0e0" : "#009399",
                  },
                }}
              >
                {actionLabel}
              </Button>
            ) : null}
            {isProvisionalOfferTab ? (
              <Button
                variant="outlined"
                onClick={provisionalOfferBtnClick}
                sx={{
                  mt: isXsOrSm ? 2 : 0,
                  border: "none",
                  textTransform: "capitalize",
                  color: "#00b3b5",
                  "&:hover": {
                    bgcolor: "white",
                    border: "none",
                  },
                }}
                disabled={!isProvisionalOffer}
                startIcon={<VisibilityIcon />}
              >
                View Provisional Offer
              </Button>
            ) : (
              pageTypeSummary !== "loansummary" ? 
                <IconButton size="small" sx={{ color: "#616161" }}>
                  {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                </IconButton>
                :null
            )}
          </Box>
        )}
      </Box>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        {headerContent && pageTypeSummary!="loansummary" &&  partnerStartedJourney===false && (
          <Box
            sx={{ pt: 2 }}
            onClick={(event) => event.stopPropagation()}
          >
            {headerContent}
          </Box>
        )}
        {pageTypeSummary!="loansummary" && subSteps && subSteps.length > 0 && partnerStartedJourney===false && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: isXsOrSm
                ? "1fr"
                : `repeat(${Math.min(subSteps.length, 3)}, minmax(0, 1fr))`,
              gap: 1.5,
              pt: 2,
            }}
          >
            {subSteps.map((step,index) => {
              const val: any = getSubStepProgress(step.completionRate);

              // 1. Look back at the previous step's progress
              const prevStep = index > 0 ? subSteps[index - 1] : null;
              const prevVal = prevStep ? getSubStepProgress(prevStep.completionRate) : 100; // First step defaults to 100 for its 'previous' baseline

              // 2. Determine if this step is the immediate next step to fill out
              const isNextUnfinishedStep = prevVal === 100 && val === 0;

              // 3. Define basic complete state
              const isComplete = val === 100 || partnerStartedJourney;

              // 4. Update core canEdit rule:
              // It can be edited if it's explicitly the next unfinished sequence step OR if it's already in progress (> 0 but < 100)
              // while ensuring the partner hasn't locked the journey.
              let canEdit = !partnerStartedJourney && !isComplete && (isNextUnfinishedStep || (val > 0 && val < 100));

              // Applicant Additional Details can't be completed until the provisional offer exists.
              const isApplicantAdditionalDetailsStep =
                step.verticalStepName === "Applicant Additional Details" ||
                step.verticalStepName === "Additional Applicant Details";
              if (isApplicantAdditionalDetailsStep && !isProvisionalGenerated) {
                canEdit = false;
              }
              const shouldShowCompleteNow = canEdit;

              // 5. Compute the UI label based on status flags
              const label = isComplete ? "Completed" : canEdit && applicationStatus==="Application Submitted" ? "Locked":"Complete Now";
              const clickHandler = () => {
                if (!partnerStartedJourney) {
                  gotoDynamicForm(step);
                }
              };
              return (
                <Card
                  key={step.verticalStepName}
                  sx={{
                    borderRadius: "12px",
                    border: "1px solid rgba(15, 23, 42, 0.08)",
                    boxShadow: "0px 4px 12px rgba(15, 23, 42, 0.04)",
                    backgroundColor: "#ffffff",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1.5,
                      px: 2,
                      py: 1.5,
                      "&:last-child": { pb: 1.5 },
                    }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Typography
                        sx={{
                          fontSize: "0.78rem",
                          fontWeight: 600,
                          color: "#344054",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {step.verticalStepName==="Verify Yourself and Provide Consent"?"Basic Details" : step.verticalStepName==="Provide Course Details"?"Course Details":step.verticalStepName==="Provide Loan Details"?"Loan Details":step.verticalStepName}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.68rem",
                          fontWeight: 600,
                          color: canEdit || shouldShowCompleteNow ? "#00b3b5" : "gray",
                          mt: 0.35,
                          cursor: partnerStartedJourney ? "default" : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                        onClick={partnerStartedJourney || label==="Completed" || label==="Locked" ||(!canEdit && !shouldShowCompleteNow) ? undefined : clickHandler}
                      >
                        {label}
                        {(canEdit || shouldShowCompleteNow) && (
                          <ArrowForwardIosIcon
                            sx={{
                              fontSize: "0.55rem",
                              fontWeight: "bold",
                              color: "#00b3b5",
                              ml: 0.5,
                              mt: "1px",
                            }}
                          />
                        )}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography
                        sx={{ fontSize: "0.78rem", fontWeight: 700, color: "#00b3b5" }}
                      >
                        {val}%
                      </Typography>
                      <Box sx={{ position: "relative", display: "inline-flex" }}>
                        <CircularProgress
                          variant="determinate"
                          value={100}
                          size={24}
                          thickness={4}
                          sx={{ color: "#dff3f3" }}
                        />
                        <CircularProgress
                          variant="determinate"
                          value={val}
                          size={24}
                          thickness={4}
                          sx={{ color: "#00b3b5", position: "absolute", left: 0, top: 0 }}
                        />
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
        )}
        <Box sx={{ pt: paddingTopTabZero ? 0 : 2 }}>{children}</Box>
      </Collapse>
    </Paper>
  );
};

export default CollapsibleSection;